<template>
  <section>
    <Title :title-name="title.Flight.titleName" :title-link="title.Flight.titleLink" />
    <div class="flight">
      <div class="container">
        <h2 class="title">Flight Information</h2>
        <div class="row flightinfo text-center">
          <div class="col-4">
            <div>From</div>
            <div class="airport-name">{{ Flight.dep }}</div>
            <div class="flight-time-der">
              <div>
                <i class="fas fa-circle" style="color: rgb(7, 188, 236)"> </i>
                {{ moment(Flight.std).format('hh:mm a') }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="frame-flight-img">
              <img src="@/assets/images/flight.png" alt="Flight picture Image" />
            </div>
          </div>
          <div class="col-4">
            <div>To</div>
            <div class="airport-name">{{ Flight.arr }}</div>
            <div class="flight-time-arr">
              <div>
                <i class="fas fa-circle" style="color: rgb(84, 206, 174)"> </i>
                {{ moment(Flight.sta).format('hh:mm a') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="flight-status">
          <p style="color: #000">
            Status:
            <span>{{ Flight.flight_status }}</span>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import '@/assets/scss/modules/Flight.scss'
import Title from '@/components/Title/index'

export default {
  name: 'Flight',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      flightStatus: 'On time',
      delay_time: ''
    }
  },
  computed: {
    ...mapGetters({
      Flight: 'Flight/Flight'
    })
  },
  mounted() {
    this.$store.dispatch('Flight/getFlight')
  },
  methods: {}
}
</script>
